import React from "react";

export default function MaterialEcgIcon({ className = "", ...props }) {
  return (
    <span
      aria-hidden="true"
      className={["material-symbols-outlined", "leading-none", className]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      ecg
    </span>
  );
}
